import React, { FC, PropsWithChildren, ReactNode, useRef } from 'react'

import { IntersectionObserver } from 'components/layout/IntersectionObserver'

export const ShowAfterIntersection: FC<
  { thumbnail?: ReactNode } & PropsWithChildren
> = ({ thumbnail, children }) => {
  const showRef = useRef(false)

  return (
    <IntersectionObserver>
      {({ setNode, entry }) => {
        if (entry?.isIntersecting) {
          showRef.current = true
        }

        return <div ref={setNode}>{showRef.current ? children : thumbnail}</div>
      }}
    </IntersectionObserver>
  )
}
